import { atom } from 'recoil';

export const isLoadingState = atom({
  key: 'isLoadingState',
  default: false,
});

export const notificationAlertState = atom({
  key: 'notificationAlertState',
  default: null,
});

// export const basicProfileDataState = atom({
//   key: 'basicProfileDataState',
//   default: {
//     firstName: '',
//     lastName: '',
//     email: '',
//     name: '',
//   },
// });

// export const additionalProfileDataState = atom({
//   key: 'additionalProfileDataState',
//   default: {
//     phone: '',
//     address: '',
//   },
// });

// export const currentUserRoleState = atom({
//   key: 'currentUserRoleState',
//   default: null,
// });

// export const rolesMapState = atom({
//   key: 'rolesMapState',
//   default: null,
// });
